var React = require('react');

function PlusGreen (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#FFF","d":"M1 8c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7-7 3.13-7 7z","key":0}),React.createElement("path",{"fill":"#38AB50","d":"M7 9v1c0 .55.45 1 1 1 .56 0 1-.44 1-1V9h1c.55 0 1-.45 1-1 0-.56-.44-1-1-1H9V6c0-.55-.45-1-1-1-.56 0-1 .44-1 1v1H6c-.55 0-1 .45-1 1 0 .56.44 1 1 1h1zM2 8c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6z","key":1})]));
}

PlusGreen.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = PlusGreen;

PlusGreen.default = PlusGreen;
